// -------------------------------------
// Dependencies
// -------------------------------------
import './_accessory-type-select.scss';

// -------------------------------------
// Variables
// -------------------------------------
const OPTION_SELECTOR = '.accessory-type-select__option';
const DESTINATION_PARAM = 'destination';
const SHARPENER_TYPE_PARAM = 'sharpener_type';
const ACCESSORY_TYPE_PARAM = 'accessory_type';

class iamAccessoryTypeSelect extends HTMLElement {

    constructor() {
        super();

        this.applyDestinationFromParams();
    }

    applyDestinationFromParams() {
        const params = new URLSearchParams(window.location.search);
        const destination = params.get(DESTINATION_PARAM);

        // No incoming destination (e.g. direct page visit) — leave the
        // Liquid-rendered fallback link on each option untouched.
        if (!destination) return;

        let destinationUrl;

        try {
            destinationUrl = new URL(destination, window.location.origin);
        } catch (error) {
            return;
        }

        const sharpenerType = params.get(SHARPENER_TYPE_PARAM);

        this.querySelectorAll(OPTION_SELECTOR).forEach((option) => {
            const optionUrl = new URL(destinationUrl);

            optionUrl.searchParams.set(ACCESSORY_TYPE_PARAM, option.dataset.accessoryType);

            if (sharpenerType) {
                optionUrl.searchParams.set(SHARPENER_TYPE_PARAM, sharpenerType);
            }

            option.href = optionUrl.toString();
        });
    }
}

customElements.define('iam-accessory-type-select', iamAccessoryTypeSelect);
